import { X } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { useMilestones } from "@/lib/milestones";

export function WelcomeCard() {
  const navigate = useNavigate();
  const { milestones, setMilestone, milestonesLoading } = useMilestones();
  const dismissed = milestones.welcome_dismissed === true;

  const dismiss = () => setMilestone("welcome_dismissed", true);

  if (dismissed) return null;
  // Avoid flashing for existing users before the DB fetch resolves.
  if (milestonesLoading) return null;

  return (
    <div className="max-w-3xl mx-auto px-8 pt-8">
      <div
        className="relative px-8 py-8 text-center"
        style={{ backgroundColor: "var(--caileve-soft)", borderTop: "1px solid var(--caileve-gold)" }}
      >
        <button
          type="button"
          aria-label="Dismiss welcome"
          onClick={dismiss}
          className="absolute top-3 right-3 p-1 hover:opacity-80 transition-opacity"
          style={{ color: "var(--caileve-muted)" }}
        >
          <X className="h-4 w-4" strokeWidth={1.5} />
        </button>
        <h2
          className="text-3xl"
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            color: "var(--caileve-ink)",
          }}
        >
          Welcome to Cailève
        </h2>
        <p
          className="mt-4 text-base leading-relaxed max-w-xl mx-auto"
          style={{ color: "var(--caileve-ink)" }}
        >
          Start by adding a piece you love — a favorite necklace, a ring you
          wear every day. Your style story begins with the pieces that mean the
          most to you.
        </p>
        <button
          type="button"
          onClick={() => {
            dismiss();
            navigate({ to: "/jewelry", search: { new: 1 } as never });
          }}
          className="mt-6 px-8 py-2.5 text-xs uppercase tracking-[0.25em] text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: "var(--caileve-lilac)" }}
        >
          Add My First Piece
        </button>
      </div>
    </div>
  );
}